import { IRecording } from '../../appointments/recording/RecordingState';
import { SelectableText } from '../../components/SelectableText';

export const AITranscription: React.FC<{ recording: IRecording; }> = ({ recording }) => {
    return recording?.transcription && (
        <SelectableText>{recording.transcription}</SelectableText>
    );
};
